module.exports = __webpack_public_path__ + "static/media/icon-chevron.7875176b.svg";